module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/28/assets/images/78a7caca0d219f3162269816c8c09edd.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_expand.svg
// module id = evse
// module chunks = 0